import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createSlots as _createSlots, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "text-black-lp-300 text-12px xxl:text-14px w-4/5" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "font-semibold" }, " ID Rate ", -1)
const _hoisted_3 = { class: "my-1 font-normal" }
const _hoisted_4 = { class: "flex flex-row" }
const _hoisted_5 = { class: "text-black-lp-300 text-12px xxl:text-14px w-4/5" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "font-semibold" }, " Kurs Awal ", -1)
const _hoisted_7 = { class: "my-1 text-gray-lp-300 inline-flex capitalize font-medium" }
const _hoisted_8 = { class: "text-black-lp-300 text-12px xxl:text-14px w-4/5" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "font-semibold" }, " Kurs Tukar ", -1)
const _hoisted_10 = { class: "my-1 text-gray-lp-300 inline-flex capitalize font-medium" }
const _hoisted_11 = { class: "flex flex-row" }
const _hoisted_12 = { class: "text-black-lp-300 text-12px xxl:text-14px w-4/5" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "font-semibold" }, " Nilai Awal ", -1)
const _hoisted_14 = { class: "my-1 font-normal w-10/12" }
const _hoisted_15 = { class: "text-black-lp-300 text-12px xxl:text-14px w-4/5" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "font-semibold" }, " Nilai Tukar ", -1)
const _hoisted_17 = { class: "my-1 font-normal w-8/12" }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "border-b-2" }, null, -1)
const _hoisted_19 = { class: "py-3 space-y-6" }
const _hoisted_20 = { class: "text-black-lp-300 text-12px xxl:text-14px w-4/5" }
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "font-semibold" }, " Tanggal Efektif ", -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "text-12px text-gray-lp-500 py-4" }, " Konfigurasi ini akan berlaku seterusnya sejak tanggal yang dipilih hingga Anda memperbaruhinya. ", -1)
const _hoisted_23 = { class: "my-1 font-normal w-8/12" }
const _hoisted_24 = { class: "text-black-lp-300 text-12px xxl:text-14px w-4/5" }
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "font-semibold" }, " Status ", -1)
const _hoisted_26 = { class: "my-1 font-normal" }
const _hoisted_27 = { class: "flex" }
const _hoisted_28 = { class: "capitalize font-medium" }
const _hoisted_29 = { class: "text-black-lp-300 text-12px xxl:text-14px w-4/5" }
const _hoisted_30 = /*#__PURE__*/_createVNode("div", { class: "font-semibold" }, " Tanggal Dibuat ", -1)
const _hoisted_31 = { class: "my-1 font-normal" }
const _hoisted_32 = { class: "text-gray-lp-500" }
const _hoisted_33 = { class: "text-black-lp-300 text-12px xxl:text-14px w-4/5" }
const _hoisted_34 = /*#__PURE__*/_createVNode("div", { class: "font-semibold" }, " Terakhir Diubah ", -1)
const _hoisted_35 = { class: "my-1 font-normal" }
const _hoisted_36 = { class: "text-gray-lp-500" }
const _hoisted_37 = { class: "inline-flex gap-x-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_button_outline = _resolveComponent("button-outline")!
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_DetailLayout, {
      onBack: _ctx.goBack,
      loading: _ctx.isLoading,
      error: _ctx.isError,
      errorType: _ctx.errorCause,
      onTryAgain: _ctx.getDetail,
      title: _ctx.title
    }, _createSlots({
      "sub-data": _withCtx(() => [
        _createVNode("div", _hoisted_24, [
          _hoisted_25,
          _createVNode("div", _hoisted_26, [
            _createVNode("div", _hoisted_27, [
              _createVNode("div", {
                class: 
                `rounded-full px-2 py-0 font-medium ${
                  _ctx.detailData.status.toLowerCase() === 'active'
                    ? 'bg-green-lp-300'
                    : _ctx.detailData.status.toLowerCase() === 'inactive'
                    ? 'bg-red-300'
                    : 'bg-yellow-lp-200'
                } ${
                  _ctx.detailData.status.toLowerCase() === 'active'
                    ? 'text-green-lp-200'
                    : _ctx.detailData.status.toLowerCase() === 'inactive'
                    ? 'text-red-lp-200'
                    : 'text-yellow-lp-100'
                }`
              
              }, [
                _createVNode("span", _hoisted_28, _toDisplayString(_ctx.setRateStatus(_ctx.detailData.status.toLowerCase())), 1)
              ], 2)
            ])
          ])
        ]),
        _createVNode("div", _hoisted_29, [
          _hoisted_30,
          _createVNode("div", _hoisted_31, _toDisplayString(_ctx.createdAt), 1),
          _createVNode("div", _hoisted_32, _toDisplayString(_ctx.createdBy), 1)
        ]),
        _createVNode("div", _hoisted_33, [
          _hoisted_34,
          _createVNode("div", _hoisted_35, _toDisplayString(_ctx.updatedAt), 1),
          _createVNode("div", _hoisted_36, _toDisplayString(_ctx.updatedBy), 1)
        ]),
        _createVNode("div", _hoisted_37, [
          (_ctx.isDeactivateAble)
            ? (_openBlock(), _createBlock(_component_button_outline, {
                key: 0,
                title: "Nonaktifkan",
                onClick: _ctx.onOpenModalDeactivate,
                class: "px-8"
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.isEditAble)
            ? (_openBlock(), _createBlock(_component_button_fill, {
                key: 1,
                title: "Ubah",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goEdit())),
                class: "px-8 bg-red-lp-300"
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 2
    }, [
      (!_ctx.isLoading)
        ? {
            name: "data",
            fn: _withCtx(() => [
              _createVNode("div", _hoisted_1, [
                _hoisted_2,
                _createVNode("div", _hoisted_3, _toDisplayString(_ctx.detailData.id), 1)
              ]),
              _createVNode("div", _hoisted_4, [
                _createVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createVNode("div", _hoisted_7, [
                    _createVNode("p", null, [
                      _createTextVNode(_toDisplayString(_ctx.detailData.exchangeRateCountryNameFrom) + " " + _toDisplayString(" - ") + " ", 1),
                      _createVNode("strong", null, _toDisplayString(_ctx.detailData.exchangeRateFrom), 1)
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createVNode("div", _hoisted_10, [
                    _createVNode("p", null, [
                      _createTextVNode(_toDisplayString(_ctx.detailData.exchangeRateCountryNameTo) + " " + _toDisplayString(" - ") + " ", 1),
                      _createVNode("strong", null, _toDisplayString(_ctx.detailData.exchangeRateTo), 1)
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_11, [
                _createVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createVNode("div", _hoisted_14, _toDisplayString(_ctx.detailData.exchangeRateFrom) + " 1 ", 1)
                ]),
                _createVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createVNode("div", _hoisted_17, _toDisplayString(_ctx.exchangeRateValue), 1)
                ])
              ]),
              _hoisted_18,
              _createVNode("div", _hoisted_19, [
                _createVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _hoisted_22,
                  _createVNode("div", _hoisted_23, _toDisplayString(_ctx.effectiveDate), 1)
                ])
              ])
            ])
          }
        : undefined
    ]), 1032, ["onBack", "loading", "error", "errorType", "onTryAgain", "title"]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx._onDeactivate,
      onClose: _ctx.onCloseModalDeactivate,
      title: "Yakin ingin nonaktifkan kurs?",
      message: "Kurs tidak dapat digunakan selama dinonaktifkan.",
      image: "are-you-sure",
      textSuccess: "Ya, nonaktif",
      textCancel: "Batal",
      isLoading: _ctx.isLoading,
      isDisabled: _ctx.isLoading,
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "isLoading", "isDisabled"]), [
      [_vShow, _ctx.openModalDeactivate]
    ])
  ], 64))
}